/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ErrorInformation } from '../model/errorInformation';
import { Storage } from '../model/storage';
import { StorageAttributesUpdateRequest } from '../model/storageAttributesUpdateRequest';
import { StorageCreateRequest } from '../model/storageCreateRequest';
import { StorageKeys } from '../model/storageKeys';
import { StorageUpdateRequest } from '../model/storageUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class StorageService {

    protected basePath = 'http://localhost/herd-app/rest';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * createStorage
     * Creates a new storage.
     * @param storageCreateRequest the information needed to create the storage
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageCreateStorage(storageCreateRequest: StorageCreateRequest, observe?: 'body', reportProgress?: boolean): Observable<Storage>;
    public storageCreateStorage(storageCreateRequest: StorageCreateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Storage>>;
    public storageCreateStorage(storageCreateRequest: StorageCreateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Storage>>;
    public storageCreateStorage(storageCreateRequest: StorageCreateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (storageCreateRequest === null || storageCreateRequest === undefined) {
            throw new Error('Required parameter storageCreateRequest was null or undefined when calling storageCreateStorage.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Storage>(`${this.configuration.basePath}/storages`,
            storageCreateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * deleteStorage
     * Deletes an existing storage by name.
     * @param storageName the storage name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageDeleteStorage(storageName: string, observe?: 'body', reportProgress?: boolean): Observable<Storage>;
    public storageDeleteStorage(storageName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Storage>>;
    public storageDeleteStorage(storageName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Storage>>;
    public storageDeleteStorage(storageName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (storageName === null || storageName === undefined) {
            throw new Error('Required parameter storageName was null or undefined when calling storageDeleteStorage.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<Storage>(`${this.configuration.basePath}/storages/${encodeURIComponent(String(storageName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getStorage
     * Gets an existing storage by name.
     * @param storageName the storage name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageGetStorage(storageName: string, observe?: 'body', reportProgress?: boolean): Observable<Storage>;
    public storageGetStorage(storageName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Storage>>;
    public storageGetStorage(storageName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Storage>>;
    public storageGetStorage(storageName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (storageName === null || storageName === undefined) {
            throw new Error('Required parameter storageName was null or undefined when calling storageGetStorage.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Storage>(`${this.configuration.basePath}/storages/${encodeURIComponent(String(storageName))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getStorages
     * Gets a list of storage keys for all storage defined in the system.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageGetStorages(observe?: 'body', reportProgress?: boolean): Observable<StorageKeys>;
    public storageGetStorages(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<StorageKeys>>;
    public storageGetStorages(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<StorageKeys>>;
    public storageGetStorages(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<StorageKeys>(`${this.configuration.basePath}/storages`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateStorage
     * Updates an existing storage.
     * @param storageName the name of the storage to update
     * @param storageUpdateRequest the information needed to update the storage
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageUpdateStorage(storageName: string, storageUpdateRequest: StorageUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<Storage>;
    public storageUpdateStorage(storageName: string, storageUpdateRequest: StorageUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Storage>>;
    public storageUpdateStorage(storageName: string, storageUpdateRequest: StorageUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Storage>>;
    public storageUpdateStorage(storageName: string, storageUpdateRequest: StorageUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (storageName === null || storageName === undefined) {
            throw new Error('Required parameter storageName was null or undefined when calling storageUpdateStorage.');
        }
        if (storageUpdateRequest === null || storageUpdateRequest === undefined) {
            throw new Error('Required parameter storageUpdateRequest was null or undefined when calling storageUpdateStorage.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Storage>(`${this.configuration.basePath}/storages/${encodeURIComponent(String(storageName))}`,
            storageUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updateStorageAttributes
     * Updates an existing storage attributes by storage name. &lt;p&gt; This endpoint replaces the entire list of attributes on the Storage with the contents of the request. Observe this example: &lt;ol&gt; &lt;li&gt;Three attributes present on the Storage.&lt;/li&gt; &lt;li&gt;This endpoint is called with a single attribute in the request with an updated value.&lt;/li&gt; &lt;li&gt;After this operation the Storage will have only one attribute – which is probably not the desired outcome.&lt;/li&gt; &lt;li&gt;Instead, supply all existing attributes and provide updated values and additional attributes as needed. The only case when an existing attribute should be left out is to remove the attribute.&lt;/li&gt; &lt;/ol&gt; &lt;/p&gt;
     * @param storageName the name of the storage
     * @param storageAttributesUpdateRequest the information needed to update storage attributes
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public storageUpdateStorageAttributes(storageName: string, storageAttributesUpdateRequest: StorageAttributesUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<Storage>;
    public storageUpdateStorageAttributes(storageName: string, storageAttributesUpdateRequest: StorageAttributesUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Storage>>;
    public storageUpdateStorageAttributes(storageName: string, storageAttributesUpdateRequest: StorageAttributesUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Storage>>;
    public storageUpdateStorageAttributes(storageName: string, storageAttributesUpdateRequest: StorageAttributesUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (storageName === null || storageName === undefined) {
            throw new Error('Required parameter storageName was null or undefined when calling storageUpdateStorageAttributes.');
        }
        if (storageAttributesUpdateRequest === null || storageAttributesUpdateRequest === undefined) {
            throw new Error('Required parameter storageAttributesUpdateRequest was null or undefined when calling storageUpdateStorageAttributes.');
        }

        let headers = this.defaultHeaders;

        // authentication (basicAuth) required
        if (this.configuration.username || this.configuration.password) {
            headers = headers.set('Authorization', 'Basic ' + btoa(this.configuration.username + ':' + this.configuration.password));
        }

        // authentication (oauthAuth) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'application/xml'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<Storage>(`${this.configuration.basePath}/storageAttributes/storages/${encodeURIComponent(String(storageName))}`,
            storageAttributesUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
